import React from 'react'
import MarkerClusterGroup from 'react-leaflet-cluster'
import { palette } from '@/javascript/presentation/helpers/palette'
import EnhancedMarker from '@/javascript/presentation/components/enhanced-marker/enhanced-marker'

type RouteMapEntry = { reference?: string; geometry?: string; points?: { reference?: string; location: { lat: number; lng: number } }[] }

const markerIconStyle = (color: string, textColor: string): React.CSSProperties => ({
  width: '25px', height: '25px', display: 'flex', alignItems: 'center',
  justifyContent: 'center', borderRadius: '50%', border: '2px solid white',
  backgroundColor: color, color: textColor,
})

const RouteMarkers = React.memo(({ groups }: { groups: RouteMapEntry[] }) => (
  <MarkerClusterGroup
    chunkedLoading
    chunkInterval={200}
    chunkDelay={50}
    animate={false}
    animateAddingMarkers={false}
    showCoverageOnHover={false}
    spiderfyDistanceMultiplier={1.25}
  >
    {groups.map((group, index) => {
      const points = group.points || []
      const groupKey = group.reference ?? String(index)
      return (
      <React.Fragment key={groupKey}>
        {points.map((point, workIndex: number) => {
          const isLast = workIndex === points.length - 1
          const first = points[0]
          if (isLast && point.location.lat === first.location.lat && point.location.lng === first.location.lng) return null
          const pointKey = point.reference ?? String(workIndex)
          return (
            <EnhancedMarker
              key={pointKey}
              position={[point.location.lat, point.location.lng]}
              icon={
                <div style={markerIconStyle(palette[index % palette.length].color, palette[index % palette.length].textColor)}>
                  {workIndex === 0 || isLast ? '' : workIndex}
                </div>
              }
            />
          )
        })}
      </React.Fragment>
    )})}
  </MarkerClusterGroup>
))

export default RouteMarkers
